import DashboardField from "DashboardUser/components/DashboardField"
import './DashboardTable.scoped.scss'
import { useAct } from 'DashboardUser/store'
import DashboardRecord from "./DashboardRecord";
import { isMobile } from 'react-device-detect';

export default function DashboardTargetTable({ }) {
  const act = useAct();

  // Getting data from your state management
  const dashboardTargets = useSel(s => _.values(s.dashboardTargets.entities));
  const { currentPage, totalPages } = useSel(s => s.local);
  const dashboardFields = useSel(s => _.orderBy(s.dashboard.dashboardFields, 'digitOrder', 'asc'));

  // Optional: Sort functionality
  // TODO: put this onto the server backend!
  const [sortFieldId, setSortFieldId] = React.useState(1);
  const [sortDirection, setSortDirection] = React.useState('asc');

  const handleSort = (field) => {
    // If clicking the same field, toggle direction
    if (field === sortFieldId) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      // New field, set to ascending by default
      setSortFieldId(field);
      setSortDirection('asc');
    }
  };

  // Sort the targets based on the selected field and direction
  const sortedTargets = useMemo(() => {
    return dashboardTargets.sort((a, b) => {
      if (a.fields[sortFieldId] < b.fields[sortFieldId]) return sortDirection === 'asc' ? -1 : 1;
      if (a.fields[sortFieldId] > b.fields[sortFieldId]) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });
  }, [dashboardTargets, sortFieldId, sortDirection]);


  // Expand/Collapse row ->record functionality
  const [expandedRows, setExpandedRows] = React.useState([]);
  const toggleExpanded = (id) => {
    if (expandedRows.includes(id)) {
      setExpandedRows(expandedRows.filter(rowId => rowId !== id));
    } else {
      setExpandedRows([...expandedRows, id]);
    }
  }

  // Pagination
  const handlePageChange = (page) => {
    page = Math.max(0, Math.min(page, totalPages));
    act.local.upsert({ currentPage: page });
    if (page !== 0) { //We allow 0 without reloading so user can interact with the page input fully
      act.app.reloadTargets();
    }
  }

  // Check if we have any targets to display
  if (!dashboardTargets || dashboardTargets.length === 0) {
    return <div className="team-table-container">You can't see anyone in this dashboard right now</div>;
  }

  return (
    <>
      <div className="team-table-container box">
        <div className="team-table-header">
          <h1>Members</h1>
        </div>
        <table className="team-table">
          <thead>
            <tr>
              <th className='meta-col'></th>
              { dashboardFields.map(df => <th
                key={df.id}
                onClick={() => handleSort(df.id)}
                className={sortFieldId === df.name ? `sort-${sortDirection}` : ''}
                >
                  <span className="field-name">{df.name}</span>
                <SvgIconsSort asc={sortFieldId === df.id && sortDirection === 'asc'} desc={sortFieldId === df.id && sortDirection === 'desc'} />
              </th>) }
            </tr>
          </thead>
          <tbody>
            {sortedTargets.map((dashboardTarget, index) => (
              <DashboardTargetRow
                key={dashboardTarget.id || index}
                dashboardTarget={dashboardTarget}
                dashboardFields={dashboardFields}
                expanded={expandedRows.includes(dashboardTarget.id)}
                onToggleExpanded={(id) => toggleExpanded(id)}
              />
            ))}
          </tbody>
        </table>
        <div className="team-table-footer">
          <div className="pagination">
            <button className='button pagination-prev' onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
              <SvgIconsBackCaret />
            </button>
            <div className="pagination-pages">
              <input type="text" className='pagination-current' value={currentPage} onChange={e => handlePageChange(Number(e.target.value))} />
              <span className='pagination-text'>of</span>
              <span className='pagination-total'>{totalPages}</span>
            </div>
            <button className='button pagination-next' onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
              <SvgIconsForwardCaret />
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

const DashboardTargetRow = ({ dashboardTarget, dashboardFields, expanded, onToggleExpanded }) => {
  return (<>
    <tr className={`${expanded ? 'expanded' : ''}`} onClick={() => isMobile ? onToggleExpanded(dashboardTarget.id) : null}>
      <td className="expand-row-icon meta-col" onClick={() => onToggleExpanded(dashboardTarget.id)}>
        { expanded ? <SvgIconsClose /> : <SvgIconsEdit color={`rgba(38, 38, 77, 0.6)`} /> }
      </td>
      { dashboardFields.map(df => <td><DashboardField key={df.id} field={df} dashboardTarget={dashboardTarget} className='flex-items-center' /></td>) }
    </tr>
    { expanded && (
      <tr className='expanded'>
        <td colSpan={dashboardFields.length + 1} className="expanded-row">
          <DashboardRecord
            dashboardFields={dashboardFields}
            dashboardTarget={dashboardTarget}
          />
        </td>
      </tr>
    )}
    <tr className='row-separator'></tr>
    </>);
};
